var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGarbage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: "30px",
    width: "30px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490 490",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.313,94.97h32.539v340.404c0,30.116,24.509,54.625,54.64,54.625h285.016c30.132,0,54.641-24.509,54.641-54.625V94.97 h32.539V49.033H337.544V0H152.455v49.033H15.313V94.97z M396.211,435.375c0,4.71-3.993,8.688-8.703,8.688H102.492 c-4.71,0-8.703-3.978-8.703-8.688V94.97h302.422V435.375z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.552,360.162 322.762,268.554 270.526,268.554 270.526,147.742 224.588,147.742 224.588,268.554  172.342,268.554  "
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarbage);
export default __webpack_public_path__ + "static/media/garbage.5aa77f4467a2ad1831f0f1835decd143.svg";
export { ForwardRef as ReactComponent };